export default __webpack_public_path__ + "static/media/logo-lsbd.41f70714.svg";